export function LocaleTranslateFilter(localeService) {
    'ngInject'
    const self = translateFilter;

    self.currentLocaleTranslations;

    activate();

    translateFilter.$stateful = true;
    return translateFilter;

    function activate() {
        // Pre-load the locale translations for the current locale.
        localeService.retrieveCurrentLocaleTranslations()
            .then(function (translations) {
                self.currentLocaleTranslations = translations;
            });
    }

    function translateFilter(input, translations) {
        let lookupTable;
        if (!translations) {
            // Lookup up the translations file with the current locale's name and return the mapped translation text.
            lookupTable = self.currentLocaleTranslations;
        } else {
            lookupTable = translations;
        }

        if (lookupTable) {
            return lookupTable[input];
        } else {
            return "-";
        }
    }
}
